/* eslint-disable max-len */
var UI_INFO = {
  "default": 'M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm9.9,25.9A14,14,0,1,1,30,16,14,14,0,0,1,25.9,25.9ZM14.56,9.83a1.8,1.8,0,1,1,1.8,1.8A1.82,1.82,0,0,1,14.56,9.83Zm3.26,12.9h2.41v2h-8v-2H14.9v-7.2H12.23v-2h5.59Z',
  globetrotter: 'M16 14.05V23.25M16 10.15C15.75 10.15 15.55 10.35 15.55 10.6C15.55 10.85 15.75 11.05 16 11.05C16.25 11.05 16.45 10.85 16.45 10.6C16.45 10.35 16.25 10.15 16 10.15ZM29.5 2.5H2.5V29.5H29.5V2.5Z'
};

export { UI_INFO };
//# sourceMappingURL=UI_INFO.js.map
